import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {api} from "../ui/api";

export const authUser = createAsyncThunk(
    'form/authUser',
    async (formData, { rejectWithValue }) => {
        try {
            const response = await api.post("/student/auth/token/", formData);

            const data = response.data;
            if (data.access) {
                localStorage.setItem("token", data.access); // Сохраняем токен в localStorage
            }

            return data; // Возвращаем данные, чтобы обновить store
        } catch (error) {
            return rejectWithValue(error.response?.data?.detail || "Authorization error");
        }
    }
);
export const patchPhotoUser = createAsyncThunk(
    'form/patchPhotoUser',
    async (photo, { rejectWithValue }) => {
        try {
            const formData = new FormData()
            formData.append("photo",photo)
            const response = await api.patch("/student/student/update_photo/", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data; // Возвращаем данные, чтобы обновить store
        } catch (error) {
            return rejectWithValue(error.response?.data?.detail || "Authorization error");
        }
    }
);
export const newPasswordUser = createAsyncThunk(
    'form/newPasswordUser',
    async (formData, { rejectWithValue }) => {
        try {
            const response = await api.patch("/student/reset-password/", formData);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data?.detail || "Authorization error");
        }
    }
);

export const getUser = createAsyncThunk(
    'form/getUser',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get("/student/student/detail/", );
            return response.data;
        } catch (error) {
            localStorage.removeItem("token");
            return rejectWithValue(error.response?.data?.detail || "Authorization error");
        }
    }
);
export const changeUserName = createAsyncThunk(
    'form/changeUserName',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.patch("/student/student/update/",data);

            return response.data;
        } catch (error) {
            localStorage.removeItem("token");
            return rejectWithValue(error.response?.data?.detail || "Authorization error");
        }
    }
);

const authSlice = createSlice({
    name: 'form',
    initialState: {
        user:null,
        email: '',
        password: '',
        loading: false,
        error: null,
        success: false,
        errorNewPassword:null,
        isAuthenticated: false,
        token: localStorage.getItem("token") || null,
    },
    reducers: {
        setAuthData: (state, action) => {
            const { field, value } = action.payload;
            state[field] = value;
            state.isAuthenticated = true;
        },
        logout: (state) => {
            state.isAuthenticated = false;
            state.token = null;
            localStorage.removeItem("token");
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(authUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(authUser.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.token = action.payload.access; // Сохраняем токен в store
                localStorage.setItem("token", action.payload.access); // Записываем в LocalStorage
            })
            .addCase(authUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Что-то пошло не так';
            })
            .addCase(getUser.pending, (state) => {
                state.loading = true;
                state.error = null;
             })
            .addCase(getUser.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload;
            })
            .addCase(getUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Что-то пошло не так';
            })
            .addCase(newPasswordUser.pending, (state) => {
                state.loading = true;
                state.error = null;
             })
            .addCase(newPasswordUser.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(patchPhotoUser.fulfilled, (state, action) => {
                state.loading = false;
                state.user = {...state.user,photo:action.payload.photo}
            })
            .addCase(changeUserName.fulfilled, (state, action) => {
                state.loading = false;
                console.log(action.payload)
                state.user = {...state.user,first_name:action.payload.first_name,last_name:action.payload.first_name}
            })
            .addCase(newPasswordUser.rejected, (state, action) => {
                state.loading = false;
                state.errorNewPassword = action.payload || 'Error';
            });
    },
});

export const { setAuthData, logout } = authSlice.actions;

export default authSlice.reducer;
